import { useQuery } from "@tanstack/react-query";

import { useApiRequest } from "@hooks/use-api-request";
import { useAuth } from "@hooks/use-auth";
import { HttpMethod } from "@lib/http.helpers";

export const useOrganizationSettingsQueryOptions = (orgCode) => {
  const queryFn = useApiRequest({
    url: `organizations/${orgCode}/settings`,
    method: HttpMethod.Get,
  });

  return {
    queryKey: ["organization-settings", orgCode],
    queryFn,
    enabled: !!orgCode,
  };
};

export const useOrganizationSettings = () => {
  const { user } = useAuth();
  return useQuery(useOrganizationSettingsQueryOptions(user?.orgCode));
};
